export default __webpack_public_path__ + "static/media/swimming.29299a3c.png";